'use client'
import { SxProps, Theme } from '@mui/material'
import MuiPagination from '@mui/material/Pagination'
import { parseAsInteger, useQueryState } from 'nuqs'
import { useEffect, useRef } from 'react'

interface PaginationProps {
  pageKey?: string
  defaultCurrent?: number
  total?: number
  className?: string
  pageSize?: number
  size?: 'small' | 'default'
  showIcon?: boolean
  onChange?: (page: number, pageSize: number) => void
  hiddenWhenEmpty?: boolean
  siblingCount?: number
  isLoading?: boolean
  sx?: SxProps<Theme>
}

export const Pagination = ({
  pageKey = 'page',
  defaultCurrent = 1,
  total = 10,
  className,
  pageSize = 10,
  onChange,
  hiddenWhenEmpty = true,
  siblingCount = 1,
  isLoading = false,
  sx,
}: PaginationProps) => {
  const [page, setPage] = useQueryState(pageKey, parseAsInteger.withDefault(1))

  const previousPageRef = useRef(page) // Lưu trang trước đó

  const handleChange = (event: React.ChangeEvent<unknown>, newPage: number) => {
    if (newPage !== page) {
      setPage(newPage)
      onChange?.(newPage, pageSize)
    }
  }

  useEffect(() => {
    if (typeof window !== 'undefined' && !isLoading && page !== previousPageRef.current) {
      const sectionScrollTo = document.querySelector('.section-scroll-to')
      if (sectionScrollTo) {
        const headerHeight = 120
        const offsetTop = sectionScrollTo.getBoundingClientRect().top + window.scrollY - headerHeight
        window.scrollTo({
          top: offsetTop,
          behavior: 'smooth',
        })
      }
      previousPageRef.current = page // Cập nhật lại sau khi scroll
    }
  }, [page, isLoading])

  if (total <= pageSize && hiddenWhenEmpty) {
    return null
  }

  return (
    <MuiPagination
      count={Math.ceil((total || 1) / pageSize)}
      onChange={handleChange}
      page={page}
      defaultPage={defaultCurrent}
      color="primary"
      className={className}
      siblingCount={siblingCount}
      sx={{
        '& .MuiPaginationItem-root:hover': {
          borderColor: 'primary.main',
          borderWidth: '1px',
          borderStyle: 'solid',
          transition: 200,
        },
        ...sx,
      }}
    />
  )
}
